<script>
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Doughnut, mixins } from 'vue-chartjs';
import numeral from 'numeral';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  components: {},
  mounted() {},
  props: ['height', 'chartData'],
  data() {
    return {
      isLoading: false,
      data: [],
      labels: []
    };
  },
  computed: {
    dataset() {}
  },
  created() {},

  mounted() {
    this.renderChart(this.chartData, {
      title: {
        display: true,
        text: 'Postage per Integration'
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      /*
      tooltips: {
        callbacks: {
          label: (tooltipItem, chart) => {
            console.log('wat', tooltipItem, chart.datasets[tooltipItem.datasetIndex])
            const label = chart.datasets[tooltipItem.datasetIndex].label || '';
            const value =
              chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ': ' + numeral(value).format('$0,0.00');
          }
        }
      }*/
    });
  },
  methods: {}
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Admin/charts/UserSpentPerIntegrationChart.vue